const it = {
    "sc_title": "Centro di sicurezza",
    "sc_subtitle": "Livello di sicurezza integrato GaiaShield",
    "sc_tab_status": "🛡️ Stato protezione",
    "sc_tab_events": "📋 Registro di sicurezza",
    "sc_tab_node": "⚙️ Sicurezza del nodo",
    "sc_loading": "Caricamento dati di sicurezza...",
    "sc_status_secured": "Stato del sistema: Account protetto",
    "sc_status_warning": "Stato del sistema: Avvisi attivi",
    "sc_desc_secured": "Non ci sono avvisi di sicurezza critici attivi. GaiaShield sta monitorando attivamente il tuo account.",
    "sc_desc_warning": "Attenzione: ci sono eventi di sicurezza attivi che richiedono la tua attenzione.",
    "sc_account_protection": "Protezione account",
    "sc_message_protection": "Protezione messaggi",
    "sc_audits": "Controlli di sicurezza",
    "sc_active": "ATTIVO",
    "sc_failed_logins": "Accessi falliti",
    "sc_tamper_checks": "Controlli manomissione",
    "sc_blocked_replays": "Replay bloccati",
    "sc_last_check": "Ultimo controllo",
    "sc_just_now": "Proprio ora",
    "sc_open_warnings": "Avvisi aperti",
    "sc_btn_acknowledge": "Conferma",
    "sc_filter_severity": "Gravità",
    "sc_filter_category": "Categoria",
    "sc_filter_hide_ack": "Nascondi confermati",
    "sc_btn_export": "Esporta",
    "sc_col_details": "Dettagli",
    "sc_col_time": "Ora",
    "sc_col_status": "Stato",
    "sc_col_action": "Azione",
    "sc_no_events": "Nessun evento di sicurezza trovato.",
    "sc_node_title": "Console di sicurezza dell'operatore di nodo",
    "sc_system_health": "Salute del sistema",
    "sc_last_audit": "Ultimo audit",
    "sc_packed_logs": "Log compressi",
    "sc_unconfirmed_events": "Eventi non confermati",
    "sc_operator_action": "Richiesta azione operatore",
    "sc_all_ok": "Tutto regolare",
    "sc_critical_events": "Eventi critici di sistema",
    "ac_title": "Centro di governance e segnalazioni",
    "ac_subtitle": "Consenso di governance e abuso di GaiaCom",
    "ac_tab_my_reports": "Le mie segnalazioni",
    "ac_tab_queue": "Coda di revisione",
    "ac_tab_operator": "Operatore di nodo",
    "ac_tab_transparency": "Federazione e trasparenza",
    "ac_loading": "Caricamento dati...",
    "ac_reported_cases": "Casi segnalati",
    "ac_no_reports": "Non hai ancora inviato alcuna segnalazione.",
    "ac_case_details": "Dettagli del caso",
    "ac_appeal_submit": "Invia ricorso",
    "ac_appeal_status": "Stato del ricorso",
    "ac_appeal_reason": "Motivo del ricorso",
    "ac_appeal_statement": "Dichiarazione",
    "ac_btn_appeal": "Invia ricorso",
    "ac_trusted_reviewer_queue": "Coda dei revisori attendibili",
    "ac_case_review": "Esamina il caso",
    "ac_review_category": "Categoria consigliata",
    "ac_review_severity": "Gravità consigliata",
    "ac_review_action": "Azione consigliata",
    "ac_review_reason": "Motivazione del revisore",
    "ac_btn_submit_review": "Invia revisione",
    "ac_node_operator_dashboard": "Cruscotto dell'operatore di nodo",
    "ac_apply_action": "Applica azione (Override)",
    "ac_target_type": "Tipo di destinazione",
    "ac_target_id": "ID di destinazione (GaiaID o ID del canale)",
    "ac_suspend": "Sospensione attiva",
    "ac_reason": "Motivo ufficiale",
    "ac_btn_apply": "Applica misura",
    "ac_transparency_title": "Registro del consenso e della trasparenza",
    "ac_transparency_desc": "Prove snapshot visibili pubblicamente di tutti i canali e le identità moderati.",
    "ac_btn_snapshot": "Crea snapshot di trasparenza",
    "search_placeholder": "Cerca email per oggetto, mittente, testo...",
    "abuse_center_title": "Centro abusi",
    "abbrechen": "Cancellare",
    "active_identities": "Identità attive",
    "active_identity": "Identità attiva",
    "add_btn": "Aggiungere",
    "add_contact_title": "Aggiungi contatto",
    "admin": "Ammin",
    "adressbuch": "directory",
    "aktiviert": "Abilitato",
    "an": "A",
    "anonymous_sender": "Mittente anonimo",
    "antworten": "Risposta",
    "attachment_gaia_hint": "Gli allegati GaiaCOM rimangono crittografati end-to-end.",
    "attachment_smtp_hint": "Il protocollo SMTP legacy blocca gli allegati eseguibili/simili a script e salva le e-mail come non sicure.",
    "attachments": "Allegati",
    "auffaellig": "Notevole",
    "auth_beta_notice": "Fase di beta testing: GaiaCOM è in fase di test attivo. Potrebbero verificarsi degli errori; proteggere i seed importanti ed esaminare attentamente i flussi di lavoro riservati.",
    "auth_btn_login": "Carica identità e accedi",
    "auth_btn_register": "Registrati e crea criptovaluta",
    "auth_copied": "Copiato",
    "auth_copy_seed": "Copia il seme",
    "auth_generate_seed": "Genera semi",
    "auth_headline": "GaiaCOM è il primo protocollo di posta elettronica e sistema di comunicazione quantistico sicuro costruito per l’umanità.",
    "auth_kicker": "Comunicazione sicura post-quantistica",
    "auth_mnemonic": "Frase mnemonica",
    "auth_mnemonic_placeholder": "12 parole separate da spazi...",
    "auth_password": "password",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Le chiavi private non lasciano il tuo dispositivo. Solo i destinatari previsti possono decrittografare il contenuto.",
    "auth_proof_gaiadata_desc": "Zero-Knowledge: mantieni il controllo dei tuoi dati. I metadati sono ridotti al minimo e non vengono utilizzati come profilo di testo semplice.",
    "auth_proof_gaiadrop_desc": "Persone esterne possono inviare SMS riservati al tuo GaiaID senza un account.",
    "auth_proof_gaiaproof_desc": "Le prove di consegna e integrità mostrano che il testo cifrato, il mittente e il timestamp non sono stati manomessi.",
    "auth_proof_gaiavault_desc": "Le note private, le note di ripristino e i record di sicurezza rimangono crittografati localmente.",
    "auth_proof_hybrid_desc": "Quantum Shield: la crittografia ibrida con ML-KEM e X25519 protegge dagli attacchi odierni e dai rischi store-now-decrypt- later.",
    "auth_secure_mail": "Posta federata quantistica sicura",
    "auth_subline": "GaiaCOM è un sistema di comunicazione quantistico sicuro per e-mail, chat, stanze di crisi, GaiaDrop e file di sicurezza locali. Le chiavi private rimangono sul tuo dispositivo, i contenuti sono crittografati end-to-end e le prove possono essere esportate senza testo normale.",
    "auth_success_btn": "Accedi ora",
    "auth_success_text": "Il tuo account GaiaCOM è stato creato. Le chiavi sono state derivate localmente dal tuo seed e non sono state archiviate sul server.",
    "auth_success_title": "Registrazione riuscita",
    "auth_tab_drop": "Gaia Drop",
    "auth_tab_login": "Accesso/Conto",
    "auth_toggle_login": "L'account esiste già",
    "auth_toggle_register": "Crea nuovo account",
    "auth_usecase_text": "Adatto ad avvocati, aziende, autorità, giornalisti, informatori e casi di sicurezza privata.",
    "auth_usecase_title": "Costruito per comunicazioni sensibili",
    "auth_username": "nome utente",
    "auth_username_placeholder": "Inserisci il nome...",
    "auth_value_chat": "Chatta E2E",
    "auth_value_drop": "Goccia sicura",
    "auth_value_mail": "Posta sicura",
    "auth_value_rooms": "GaiaRooms",
    "bestaetigen": "Confermare",
    "bestaetigt": "Confermato",
    "bio_status": "Biografia/Stato",
    "biography": "biografia",
    "change_password_desc": "Modifica la password di accesso lato server. La tua frase di ripristino locale rimane protetta separatamente dalla tua password di vault/sblocco.",
    "change_password_menu_desc": "Aggiorna la password di accesso a GaiaCOM.",
    "change_password_title": "Cambiare la password",
    "channel_id": "ID del canale",
    "channel_name_label": "Nome del canale",
    "chat_deleted_hidden": "Chat cancellata e nascosta.",
    "chat_input_placeholder": "Inserisci un messaggio sicuro...",
    "chat_start_hint": "Inizia la conversazione! Tutti i messaggi di chat sono crittografati E2E con sicurezza quantistica.",
    "choose_avatar": "Scegli l'avatar",
    "ciphertext_hash": "Hash del testo cifrato",
    "clear_chat": "Chiacchierata vuota",
    "clear_for_everyone": "Vuoto per tutti",
    "clear_for_me": "Vuoto solo per me",
    "click_to_write_mail": "Fare clic per scrivere un'e-mail",
    "click_top_right": "Clicca in alto a destra",
    "close": "Vicino",
    "code_kopieren": "Copia il codice",
    "code_kopieren_success": "Codice copiato",
    "confirm_clear_channel_desc": "Vuoi cancellare questo canale dalla tua visualizzazione locale?",
    "confirm_clear_channel_title": "Canale vuoto",
    "confirm_clear_chat": "Vuoi svuotare questa chat?",
    "confirm_clear_chat_desc": "Vuoi svuotare questa chat?",
    "confirm_clear_chat_title": "Chiacchierata vuota",
    "confirm_clear_everyone": "Vuoi svuotare la chat per entrambi i partner? (OK = Per tutti, Annulla = Solo per me)",
    "confirm_delete_everyone": "Vuoi eliminare il messaggio per entrambi i partner? (OK = Per tutti, Annulla = Solo per me)",
    "confirm_delete_msg": "Vuoi eliminare questo messaggio?",
    "confirm_delete_msg_desc": "Vuoi eliminare questo messaggio di chat?",
    "confirm_delete_msg_title": "Elimina messaggio",
    "confirm_new_password": "Conferma la nuova password",
    "copy": "Copia",
    "create_btn": "Creare",
    "create_channel_title": "Crea canale",
    "create_group_is_crisis": "Contrassegnare come area di crisi",
    "create_group_title": "Crea nuovo gruppo",
    "crypto_lock_desc": "Controlla quando GaiaCOM rimuove le chiavi crittografiche locali dalla memoria.",
    "crypto_lock_menu_desc": "Controlla i timer di ricarica e di inattività.",
    "crypto_lock_title": "Blocco crittografico",
    "crypto_session_duration": "Sbloccato dopo la ricarica",
    "crypto_session_duration_desc": "Mantiene aperta la sessione di crittografia in questa scheda del browser solo per la durata selezionata.",
    "cryptographic_fingerprint": "Impronta crittografica",
    "current_password": "password attuale",
    "data_minimization": "Minimizzazione dei dati",
    "decrypt_failed": "Non decifrabile",
    "delete": "Eliminare",
    "delete_account_button": "Elimina l'account irrevocabilmente",
    "delete_account_confirm_label": "Immettere ELIMINA per confermare",
    "delete_account_confirmation_error": "Sono necessarie la password e la conferma dell'ELIMINA.",
    "delete_account_desc": "Questa modalità distrugge permanentemente il tuo account, le tue identità, le sessioni del dispositivo, i dati GaiaDrop, i metadati di caricamento e i messaggi attribuibili sul lato server.",
    "delete_account_done_desc": "Tutti i dati GaiaCOM assegnabili sono stati cancellati.",
    "delete_account_done_title": "Conto eliminato",
    "delete_account_menu_desc": "Distruggi l'account e i dati associati.",
    "delete_account_not_authenticated": "Nessun account attivo.",
    "delete_account_title": "Elimina account",
    "delete_for_everyone": "Elimina per tutti",
    "delete_for_me": "Elimina solo per me",
    "device_current": "Questo dispositivo",
    "device_last_seen": "Scorso",
    "device_logout": "Esci",
    "device_sessions_desc": "Controlla le sessioni attive e annulla la registrazione dei dispositivi di cui non ti fidi più.",
    "device_sessions_empty": "Nessun dispositivo trovato.",
    "device_sessions_menu_desc": "Gestisci e termina le sessioni attive.",
    "device_sessions_title": "Dispositivi registrati",
    "device_since": "Da",
    "display_name": "Nome da visualizzare",
    "drop_address_copied": "Indirizzo GaiaDrop copiato.",
    "drop_btn_decrypting": "La posta in arrivo viene decrittografata...",
    "drop_btn_load": "Carica la posta in arrivo di GaiaDrop",
    "drop_delete_desc": "Vuoi davvero eliminare definitivamente questo drop?",
    "drop_delete_title": "Elimina GaiaDrop",
    "drop_desc": "Canale di solo testo a conoscenza zero per avvisi esterni, divulgazione responsabile e segnalazioni riservate. Le parti esterne possono inviare messaggi senza un account utilizzando il tuo GaiaID.",
    "drop_empty": "Nessun messaggio GaiaDrop ancora caricato.",
    "drop_id": "ID rilascio:",
    "drop_own_address": "Il tuo indirizzo GaiaDrop",
    "drop_proof": "A PROVA DI CADUTA",
    "drop_title": "Posta in arrivo sicura GaiaDrop",
    "dunkler_modus": "Modalità oscura",
    "e2e_chat_room_open": "Apri la chat room E2E",
    "edit_profile": "Modifica profilo",
    "edit_profile_desc": "Personalizza il nome visualizzato, la biografia e l'avatar.",
    "einladungscode": "Codice invito",
    "enter_fingerprint_chars_confirm": "Immettere i caratteri dell'impronta digitale richiesti per confermare.",
    "envelope_hash": "Hash della busta",
    "erasability": "Cancellabilità",
    "erfolg": "Successo",
    "exclude_plaintext": "Esporta senza testo normale",
    "export_disclosure": "Esporta caso di sicurezza",
    "export_package_desc": "Includere solo testo semplice se questa divulgazione è intesa intenzionalmente.",
    "export_package_title": "Pacchetto sicurezza esportazione",
    "fehler": "Errore",
    "gaiacom_reader": "Lettore GaiaCOM",
    "gaiadrop_inbox_title": "Posta in arrivo di GaiaDrop",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM riduce al minimo i metadati, mantiene le chiavi private locali, crittografa i contenuti end-to-end e consente la cancellazione completa dell'account.",
    "gdpr_home_title": "Conforme al 100% al GDPR",
    "gdpr_reason_delete": "L'eliminazione dell'account rimuove account, identità, sessioni locali e dati assegnabili lato server.",
    "gdpr_reason_e2ee": "Il contenuto privato rimane decifrabile solo per i destinatari previsti.",
    "gdpr_reason_minimal": "I metadati vengono utilizzati solo per il routing, la consegna e le credenziali di sicurezza.",
    "gdpr_reason_zero_knowledge": "Le chiavi private e i dati di ripristino rimangono localmente sotto il controllo dell'utente.",
    "gesendet": "Inviato",
    "gesperrt_verdaechtig": "Bandito/Sospetto",
    "group_delete_desc": "Vuoi davvero eliminare definitivamente questo gruppo? Tutti i canali e i messaggi in questo gruppo verranno eliminati.",
    "group_delete_title": "Elimina gruppo",
    "group_description": "Descrizione",
    "group_icon_label": "Icona/avatar del gruppo",
    "group_name": "Nome del gruppo",
    "group_settings_avatar": "Avatar",
    "group_settings_desc": "Descrizione",
    "group_settings_is_crisis": "Contrassegnare come area di crisi",
    "group_settings_name": "Nome del gruppo",
    "group_settings_title": "Impostazioni del gruppo",
    "groups_empty_desc": "Crea uno spazio di lavoro sicuro per progetti, crisi o comunicazioni di gruppo.",
    "groups_empty_title": "Nessuna chat di gruppo ancora",
    "gruppe_beitreten": "Gruppo unito",
    "gruppe_erstellen": "+ Crea gruppo",
    "gruppe_verlassen": "Lascia il gruppo",
    "gruppen_chats": "Chat di gruppo",
    "heller_modus": "Modalità luminosa",
    "how_to_receive_drops": "Come ricevo i drop?",
    "identitaets_assistent": "Assistente all'identità",
    "inactivity_lock_duration": "Blocca quando inattivo",
    "inactivity_lock_duration_desc": "Dopo questo periodo senza input, GaiaCOM verrà automaticamente bloccato crittograficamente.",
    "inactivity_lock_notice": "GaiaCOM è stata bloccata crittograficamente per inattività.",
    "include_plaintext": "Includi testo semplice",
    "invite_code_label": "Codice invito",
    "join_group_title": "Unisciti al gruppo",
    "kanaele": "Canali",
    "kanal_erstellen": "+canale",
    "kein_chat_ausgewaehlt": "Nessuna chat selezionata",
    "kein_kanal_ausgewaehlt": "Nessun canale selezionato",
    "keine_gruppe_ausgewaehlt": "Nessun gruppo selezionato",
    "keine_mails": "Nessuna email disponibile.",
    "key_change_warn_desc": "La chiave pubblica di questo contatto è cambiata. Controlla l'impronta digitale prima di fidarti.",
    "key_change_warn_title": "Avviso crittografico",
    "key_change_warning_changed": "è cambiato. Questo potrebbe essere il segno di un attacco man-in-the-middle!",
    "key_change_warning_msg": "Chiave di identità per il contatto",
    "key_transparency": "Trasparenza chiave",
    "kopiert": "Copiato",
    "kryptographische_schluessel": "Chiavi crittografiche",
    "kryptographische_schluessel_desc": "Mostra le chiavi private e la frase seed di backup.",
    "laden": "Carico...",
    "leeren": "Vuoto",
    "loading": "Carico...",
    "local_key_vault": "Insieme di credenziali delle chiavi locale",
    "local_keys_label": "Chiavi locali",
    "lock_on_reload": "Bloccare sempre dopo la ricarica",
    "logout": "Esci",
    "mail_compose": "Scrivi e-mail",
    "mein_profil": "Il mio profilo",
    "melden": "Rapporto",
    "menu": "menu",
    "message": "Notizia",
    "message_id": "ID del messaggio",
    "message_pin": "Spillo",
    "message_pinned_title": "Messaggi fissati",
    "message_react": "Reagire",
    "message_reply": "Risposta",
    "message_replying_to": "Rispondi a",
    "message_save": "Salva",
    "message_saved": "Salvato",
    "message_to_channel": "Messaggio a",
    "message_unpin": "Risolvere",
    "message_unsave": "Non salvare",
    "mitglied": "Membro",
    "mitglieder": "membri",
    "ml_kem": "ML-KEM",
    "neue_mail": "Nuova e-mail",
    "never_auto_lock": "Mai automaticamente",
    "new_fingerprint": "Nuova impronta digitale",
    "new_identity": "Nuova identità",
    "new_password": "Nuova password",
    "no_description": "Nessuna descrizione",
    "no_key_history": "Nessuna cronologia chiave registrata.",
    "no_specification": "Non specificato",
    "old_fingerprint": "Vecchia impronta digitale",
    "open_privacy_imprint": "Stampa aperta e protezione dei dati",
    "post_quantum_e2e": "E2E post-quantistico",
    "posteingang": "Posta in arrivo",
    "powered_by": "Offerto da",
    "privacy_imprint_menu_desc": "Mostra GDPR, protezione dei dati e note legali.",
    "privacy_imprint_profile_desc": "GaiaCOM elabora i contenuti della comunicazione secondo i principi di minimizzazione dei dati, crittografia end-to-end e controllo della chiave locale.",
    "privacy_imprint_title": "Protezione dei dati e note legali",
    "profil": "profilo",
    "profile_details": "Dettagli del profilo",
    "profile_settings_hint": "Le impostazioni del profilo vengono visualizzate nel pannello di destra.",
    "profile_unlock_desc": "Per motivi di sicurezza, è necessario reinserire la password per visualizzare le chiavi crittografiche private.",
    "proof_hash": "Hash di prova:",
    "public_drop_desc": "Secure Drop per informazioni di testo esterne senza un account GaiaCOM.",
    "public_drop_message": "Notizia",
    "public_drop_message_placeholder": "Inserisci testo riservato...",
    "public_drop_send": "Invia GaiaDrop",
    "public_drop_sender": "Nota del mittente facoltativa",
    "public_drop_sender_placeholder": "Nome, numero di pratica o anonimo",
    "public_drop_target": "Obiettivo GaiaID",
    "quanten_chat": "Chat quantistica",
    "quantum_secure_exchange": "Scambio quantistico sicuro tramite...",
    "quantum_secure_net": "Rete sicura quantistica GaiaCOM (Ed25519 e ML-KEM)",
    "quantum_shield_desc": "La rete GaiaCOM protegge la tua privacy con un protocollo di crittografia ibrido multistrato protetto dagli attacchi dei futuri computer quantistici.",
    "quantum_shield_l1_desc": "Utilizza lo standard FIPS 203 per incapsulare una chiave condivisa simmetrica. Impedisce la registrazione passiva e la successiva decrittografia (\\",
    "quantum_shield_l1_title": "1. Protezione post-quantistica (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Una classica procedura di scambio chiavi Diffie-Hellman estremamente veloce che funge da ulteriore livello di sicurezza nella procedura ibrida.",
    "quantum_shield_l2_title": "2. Crittografia a curva ellittica (X25519)",
    "quantum_shield_l3_desc": "Ogni messaggio e ogni busta della Federazione è firmata crittograficamente per verificare inequivocabilmente l'autenticità del mittente.",
    "quantum_shield_l3_title": "3. Firme digitali (Ed25519)",
    "quantum_shield_l4_desc": "Crittografa il contenuto del messaggio in modo simmetrico e collega strettamente il mittente, il destinatario e i metadati negli Authenticated Additional Data (AAD) per prevenire attacchi di riproduzione.",
    "quantum_shield_l4_title": "4. Autenticazione AAD (AES-256-GCM)",
    "quantum_shield_status": "Stato dello Scudo Quantico",
    "receive_drops_step1": "Condividi il tuo GaiaID (ad esempio utilizzando il pulsante Copia sopra) con fonti esterne.",
    "receive_drops_step2": "Questi richiamano la pagina di accesso della tua istanza GaiaCOM e passano alla scheda",
    "receive_drops_step3": "e invia il loro messaggio crittografato al tuo indirizzo.",
    "receiver_gaia": "Ricevitore GaiaCOM",
    "receiver_smtp": "Destinatario SMTP",
    "records_stored": "Record salvati",
    "refresh": "Aggiornamento",
    "report_abuse_desc": "Vuoi segnalare questo messaggio e inviare prove crittografiche di abuso al server?",
    "report_abuse_title": "Segnala un abuso",
    "reputation_status": "Stato della reputazione",
    "room_chat_start_hint": "Inizia la conversazione! Tutti i messaggi in questo canale di gruppo sono crittografati E2E decentralizzati con sicurezza quantistica.",
    "room_policy_audit": "Audit trail e rotazione delle chiavi attivi.",
    "room_policy_crisis": "Sala crisi",
    "room_policy_e2ee": "Spazio a conoscenza zero. E2EE sicuro quantistico.",
    "room_policy_title": "Linee guida per la stanza",
    "room_policy_zero_knowledge": "Politica",
    "room_security_note_desc": "Tutte le modifiche chiave vengono convalidate tramite Key Transparency. Utilizza GaiaVault per i registri di backup privati.",
    "room_security_note_title": "Nota di sicurezza appuntata",
    "save_profile": "Salva profilo",
    "schluessel_entsperrt": "🔑 Blocca nuovamente la chiave",
    "search_gaia_label": "Trova l'indirizzo di Gaia",
    "security_warning_title": "Avviso di sicurezza",
    "select_channel_chat": "Seleziona un canale dalla barra laterale sinistra per chattare.",
    "select_contact_chat": "Seleziona un contatto dal pannello di sinistra per avviare una chat E2E quantistica.",
    "select_mail_read": "Seleziona un'e-mail dall'elenco per leggerne il contenuto quantistico o creare un nuovo messaggio.",
    "senden": "Inviare",
    "sender_signature": "Firma del mittente",
    "server_log": "Registro del server:",
    "server_received": "Server ricevuto",
    "session_lock": "Blocco della sessione",
    "setup_address_keys": "Creare indirizzo e set di chiavi",
    "setup_profile": "Impostato nel profilo",
    "smtp_inbox_title": "Ricezione SMTP",
    "smtp_legacy_badge": "SMTP legacy/non sicuro",
    "smtp_mode_option": "Bridge SMTP precedente",
    "smtp_security_warning": "Questa email è stata trasmessa tramite il classico protocollo SMTP non crittografato. Nessuna crittografia end-to-end attiva.",
    "smtp_security_warning_desc": "Questo messaggio sta lasciando la stanza di sicurezza di GaiaCom. La consegna SMTP non fornisce la garanzia end-to-end nativa di GaiaCom, nessuna garanzia TrustMesh e nessuna garanzia Godmode dal gateway.",
    "spam_verdacht": "Spam/sospetto",
    "spam_warning_desc": "Questo messaggio presenta segnali di reputazione sospetti.",
    "spam_warning_title": "Avviso di spam",
    "speichern": "Salva",
    "sperren": "Bloccare",
    "standard_group_status": "Chat di gruppo standard (crittografata E2EE)",
    "status": "stato",
    "subject": "Per quanto riguarda",
    "suchen": "Trova un nuovo indirizzo Gaia...",
    "tage": "giorni",
    "time_unknown": "Orario sconosciuto",
    "transmission_mode": "Modalità di trasferimento",
    "trust_age": "Età della fiducia",
    "trust_passport_title": "Passaporto di fiducia",
    "unbestaetigt": "Non confermato",
    "unknown_sender": "Sconosciuto",
    "unlock_btn": "Sbloccare",
    "unlock_btn_profile": "Sbloccare",
    "unlock_desc": "Il file della tua chiave privata viene archiviato crittografato. Inserisci la tua password per caricare solo le chiavi crittografiche in memoria.",
    "unlock_logout": "Disconnettersi e chiudere le chiavi locali",
    "unlock_title": "Sblocca l'identità",
    "untrusted": "Non affidabile",
    "update_password": "Aggiorna password",
    "upload_avatar_btn": "Carica immagine (igienizzata)",
    "vault_btn_encrypt": "Crittografare il record",
    "vault_btn_lock": "Blocca la cassaforte",
    "vault_btn_unlock": "Sblocca la cassaforte",
    "vault_copied_success": "Copiato negli appunti",
    "vault_decrypted_content": "Contenuto decriptato",
    "vault_desc": "Deposito locale crittografato per backup di ripristino, note di identità, accesso al server, contatti di emergenza, note legali, eventi di sicurezza e registri privati.",
    "vault_empty": "Nessun record protetto ancora salvato.",
    "vault_locked_pane_notice": "La cassaforte è chiusa a chiave. Si prega di sbloccare a destra.",
    "vault_new_record": "Nuovo record sicuro",
    "vault_pwd_placeholder": "Inserisci la password della cassaforte...",
    "vault_record_body": "Registra il contenuto",
    "vault_record_body_placeholder": "Inserisci il contenuto del record crittografato...",
    "vault_record_category": "categoria",
    "vault_record_title": "Titolo del disco",
    "vault_record_title_placeholder": "Titolo del record protetto",
    "vault_title": "GaiaVault registra in modo sicuro",
    "verify_new_fingerprint_hint": "Controllare la nuova impronta digitale prima di accettare la chiave.",
    "vertrauenswuerdig": "Affidabile",
    "vision_gaia_technology": "VisionGaiaTecnologia",
    "von": "Da",
    "warnung": "avvertimento",
    "wizard_address": "indirizzo",
    "wizard_back": "Indietro",
    "wizard_check1": "Ho salvato in modo sicuro il mio seme.",
    "wizard_custom_domain": "Utilizza il tuo dominio",
    "wizard_desc1": "GaiaCOM non memorizza le chiavi private lato server. Senza Mnemonic Seed nessuno può recuperare i messaggi perduti.",
    "wizard_desc2": "Il tuo indirizzo determina il nodo federato attraverso il quale vengono instradate le buste crittografate.",
    "wizard_fallback": "Nodi di fallback",
    "wizard_finish": "Configurazione completa",
    "wizard_next": "Ulteriore",
    "wizard_server_domain": "Dominio del nodo server",
    "wizard_step1": "1. Seme di backup",
    "wizard_step2": "2. Indirizzo e server",
    "wizard_title1": "Eseguire il backup della chiave di ripristino",
    "wizard_title2": "Seleziona l'indirizzo GaiaCOM",
    "write_message_placeholder": "Scrivi un messaggio sicuro...",
    "you": "Voi",
    "zero_knowledge": "Conoscenza zero",
    "zero_knowledge_encryption": "Crittografia a conoscenza zero",
    "Chat fuer alle geleert": "La chat è stata svuotata per tutti i partecipanti.",
    "Chat geleert": "La chat è stata cancellata per la tua casella di posta locale.",
    "Nachricht fuer alle geloescht": "Il messaggio è stato eliminato per tutti i partecipanti.",
    "Nachricht geloescht": "Il messaggio di chat è stato rimosso localmente dalla tua casella di posta.",
    "anpinnen": "Spillo",
    "chat_loeschen": "Elimina la chat",
    "confirm_delete_chat_desc": "Sei sicuro di voler eliminare e nascondere la chat?",
    "confirm_leave_group_desc": "Vuoi davvero lasciare questo gruppo?",
    "entpinnen": "Sblocca",
    "group_deleted": "Gruppo eliminato correttamente.",
    "group_left": "Lascia il gruppo con successo.",
    "gruppe_loeschen": "Elimina gruppo",
    "loeschen": "Eliminare",
    "no_active_chats": "Nessuna chat attiva. Cerca i contatti qui sopra per avviare una chat.",
    "pinned": "Appuntato",
    "wizard_check_credentials": "Sono responsabile della sicurezza dei miei dati di accesso.",
    "wizard_check_is_beta": "Capisco che GaiaCom è un software beta.",
    "wizard_check_no_illegal": "Non utilizzerò GaiaCom per scopi illegali.",
    "wizard_check_no_uptime": "Capisco che non vi è alcuna garanzia di disponibilità.",
    "wizard_check_smtp_security": "Comprendo che i messaggi SMTP non forniscono la completa sicurezza GaiaCom.",
    "wizard_check_terms_read": "Ho letto i Termini di servizio della beta.",
    "wizard_step_terms": "Termini di utilizzo",
    "wizard_terms_text": "Termini di utilizzo di GaiaCom e accordo di beta testing (fase beta)\n\nFornitore: VisionGaiaTechnology (di seguito denominato “Fornitore”)\nStato: fase di beta testing pubblica\nValidità: dal 21 giugno 2026\n\n⚠️ LA NOTA PIÙ IMPORTANTE IN ANTICIPO (LEGGERE ATTENTAMENTE)\nGaiaCom è in fase di beta testing pubblico. Nonostante ampie misure di sicurezza, non è possibile garantire l’assenza di errori, la disponibilità continua o l’assoluta sicurezza del software e dell’infrastruttura sottostante. Utilizzare a proprio rischio. Gli utenti sono responsabili della conservazione sicura dei propri dati di accesso (in particolare delle chiavi per GaiaVault) e del rispetto delle leggi applicabili.\n\n1. Oggetto e scopo della fase di beta test\n1.1. Scopo della fornitura: GaiaCom è un nuovo servizio di posta elettronica e chat basato sulla crittografia post-quantistica (PQC). La fornitura durante la fase beta è destinata esclusivamente ai test tecnici, alla simulazione del carico, all'individuazione di errori di programma (bug) e all'ottimizzazione della facilità d'uso.\n1.2. Stato beta: l'utente è consapevole che il software offerto è una versione preliminare (software beta). Questo non è ancora completamente sviluppato dal punto di vista tecnico, non soddisfa lo standard di un prodotto finale e commerciale e può causare errori, perdita di dati, ritardi di trasmissione o arresti anomali del sistema.\n1.3. Nessun diritto alla continuazione: l'offerente ha il diritto in qualsiasi momento di interrompere del tutto o in parte il servizio, di modificare o limitare le funzioni oppure di rimuoverle temporaneamente o permanentemente senza indicarne i motivi.\n\n2. Disponibilità ed esclusione di garanzia\n2.1. Nessuna garanzia di disponibilità: GaiaCom viene fornito senza alcuna garanzia di disponibilità o uptime. Non esiste alcun diritto alla disponibilità ininterrotta del servizio.\n2.2. Esclusione di garanzia: il software viene fornito nel suo stato attuale (\"così com'è\") e soggetto a disponibilità. Nella misura consentita dalla legge, sono escluse eventuali richieste di garanzia per difetti materiali e legali del software. In particolare non vi è alcuna garanzia che il software sia privo di errori, privo di malware o adatto a uno scopo particolare.\n\n3. Gestione del rischio e obblighi degli utenti\n3.1. Divieto di archiviazione di dati critici: l'utente si impegna a non archiviare o trasmettere esclusivamente tramite GaiaCom dati critici per l'azienda, vitali, necessari dal punto di vista operativo o giuridicamente particolarmente sensibili (come cartelle cliniche, dati finanziari altamente sensibili o segreti regolamentati ufficialmente). Il servizio non può essere utilizzato per infrastrutture in cui guasti imprevisti potrebbero causare lesioni personali, danni materiali o perdite finanziarie significative.\n3.2. Backup auto-responsabile: L'utente è responsabile del backup di tutti i dati ricevuti o inviati tramite GaiaCom di cui ha bisogno a lungo termine sui propri sistemi indipendenti (copie di backup). Il fornitore non garantisce la memorizzazione permanente o la ripristinabilità dei dati sui propri server.\n\n4. Funzionalità crittografiche e GaiaVault\n4.1. Crittografia post-quantistica (PQC): GaiaCom implementa processi di crittografia all’avanguardia e orientati al futuro, progettati per resistere agli attacchi dei futuri computer quantistici. Tuttavia, l'utente è consapevole che si tratta di un campo scientifico dinamico e nuovo. Allo stato attuale della scienza e della tecnologia non è possibile garantire una sicurezza assoluta e inconfutabile. Termini come “sicuro al 100%, “non crackabile” o “militare sicuro” non sono espressamente garantiti.\n4.2. Nessuna garanzia di recupero (GaiaVault): GaiaCom si affida a un concetto di sicurezza coerente a conoscenza zero. I cunei di crittografia e i dati di accesso rimangono esclusivamente sotto il controllo dell'utente (protetti tramite GaiaVault).\nIMPORTANTE: se l'utente perde password, passphrase, chiavi private o seed di ripristino, il provider non ha la capacità tecnica di ricostruire o reimpostare questi dati. La perdita di questi dati di accesso porta inevitabilmente alla perdita irrevocabile dell'accesso all'account utente e a tutti i dati in esso crittografati.\n4.3. Non ancora completamente controllato: il software è continuamente sottoposto a controlli di sicurezza interni, ma al momento di questa fase beta non è ancora stato sottoposto a un controllo di sicurezza esterno finale e completo da parte di organismi di test indipendenti.\n\n5. Interfacce, protocolli legacy e federazione\n5.1. SMTP Bridge Nota: GaiaCom offre la possibilità di comunicare tramite i classici protocolli di posta elettronica (come SMTP). L'utente è consapevole che i messaggi che escono dall'area di sicurezza nativa di GaiaCom (ad esempio se inviati ad un indirizzo convenzionale @gmail.com o @gmx.de) vengono trasportati tramite server non crittografati o di terze parti. Le garanzie di sicurezza end-to-end di GaiaCom si applicano solo in misura limitata o non si applicano affatto a tali messaggi legacy in uscita o in entrata esternamente.\n5.2. Nota sulla Federazione: Se GaiaCom opera su una rete federata, i messaggi e i dati potrebbero passare attraverso server di terze parti. Mentre il contenuto dei messaggi rimane protetto mediante crittografia end-to-end, i metadati (come l'ora di invio, gli indirizzi IP dei server coinvolti e gli indirizzi dei destinatari) possono essere tecnicamente visibili agli operatori di questi server federati. Il fornitore non ha alcuna influenza sulle pratiche di protezione dei dati degli operatori di server terzi nella rete federata.\n\n6. Usi accettabili e attività vietate\nL'utente si impegna a non utilizzare il servizio in modo improprio o per scopi illegali. In particolare sono vietati:\n- Distribuire, inviare o ospitare virus, malware, contenuti di phishing o altro software dannoso.\n- Utilizzo del Servizio per condurre attacchi Denial of Service (DDoS) o invii di posta in blocco non richiesti (spam).\n- Abusare del sistema per commettere frodi.\n- Distribuzione o scambio di contenuti illegali, in particolare raffigurazioni di abusi sessuali su minori (CSAM), propaganda terroristica, inviti alla violenza o altri contenuti penalmente rilevanti.\n\n7. Sistema di segnalazione degli abusi\n7.1. Segnalazione di comportamenti abusivi: gli utenti hanno la possibilità di segnalare comunicazioni abusive o attività illegali tramite il sistema di abusi integrato.\n7.2. Elaborazione delle segnalazioni: per garantire la protezione contro gli abusi, le segnalazioni in arrivo possono essere analizzate tecnicamente (mantenendo i limiti di privacy e crittografia). Ciò può portare alla sospensione temporanea o permanente degli account utente o degli indirizzi IP in caso di comprovate violazioni delle presenti condizioni d'uso.\n\n8. Limitazione di responsabilità\n8.1. Standard di responsabilità: il software beta viene fornito gratuitamente. Secondo le norme legali per donazioni o prestiti, l'offerente è quindi responsabile solo in caso di dolo (danno intenzionale) e negligenza grave.\n8.2. Esclusione di responsabilità per la perdita di dati: La responsabilità per la perdita di dati è esclusa a meno che la perdita non sia stata causata intenzionalmente o per negligenza grave da parte del fornitore e l'utente non abbia adempiuto al proprio obbligo di mitigare il danno attraverso backup regolari (al di fuori di GaiaCom).\n8.3. Limiti legali: le limitazioni di responsabilità di cui sopra non si applicano ai danni alla vita, al corpo o alla salute o alla responsabilità ai sensi della legge sulla responsabilità del prodotto.\n\n9. Fonte aperta\nAlcuni componenti, librerie o applicazioni client GaiaCom possono essere concessi in licenza con licenze open source (ad esempio GPL, MIT, Apache). I rispettivi termini di licenza di questi componenti rimangono inalterati dalle presenti condizioni di utilizzo e possono essere visualizzati nei corrispondenti repository del codice sorgente.\n\n10. Controllo e conformità delle esportazioni\nL'utente è consapevole che il software crittografico può essere soggetto a severi controlli sulle esportazioni e restrizioni legali. L'utente è responsabile di garantire che l'utilizzo di GaiaCom non violi le leggi, le restrizioni all'importazione/esportazione o le normative sulla crittografia del rispettivo paese di residenza.\n\n11. Informativa sulla privacy (versione breve per la versione beta)\n11.1. Raccolta minima dei dati: nell'ambito della fase beta il fornitore raccoglie solo i dati assolutamente necessari per il funzionamento tecnico, la risoluzione dei problemi e l'ulteriore sviluppo (ad es. file di registro del server per la diagnosi degli errori).\n11.2. Nessuna visione del contenuto: grazie alla costante crittografia a conoscenza zero e E2E, il provider non ha mai accesso ai contenuti delle tue chat, e-mail o chiavi archiviate in GaiaVault.\n11.3. Dichiarazione dettagliata sulla protezione dei dati: le norme dettagliate sulla protezione dei dati sono collegate separatamente e devono essere prese in considerazione anche dall'utente prima della registrazione.\n\n12. Disposizioni finali\n12.1. Legge applicabile: Si applica la legge della Repubblica Federale Tedesca, ad esclusione della Convenzione delle Nazioni Unite sui contratti di vendita internazionale di merci.\n12.2. Con riserva di modifiche: poiché GaiaCom è in fase di sviluppo attivo, il fornitore si riserva il diritto di adattare queste condizioni in qualsiasi momento con effetto per il futuro. La versione attuale è disponibile nell'applicazione.",
    "wizard_terms_title": "Termini di utilizzo di GaiaCom e accordo di beta testing (fase beta)",
    "node_operator": "Operatore del nodo",
    "search_channels": "Cerca canali...",
    "senior_reviewer": "Revisore senior",
    "trusted_reviewer": "Revisore fidato",
    "active_frequencies": "Frequenze attive",
    "connected_rooms": "SPAZI CONNESSI",
    "dashboard": "Pannello di controllo",
    "empty_chats": "Nessuna chat attiva disponibile.",
    "empty_messages": "Nessun nuovo messaggio disponibile.",
    "encrypted": "Crittografato",
    "gaiacom_uplink": "COLLEGAMENTO GAIACOM",
    "install_app": "Installa l'app",
    "install_app_desc": "Per l'avvio rapido e la modalità offline",
    "kommandozentrale_alpha": "Centro di comando ALFA",
    "network_online": "RETE: ONLINE",
    "new_room": "Nuovo spazio",
    "no_frequencies_active": "Nessuna frequenza attiva. Crea una nuova stanza per iniziare la comunicazione.",
    "no_id": "Nessun documento d'identità",
    "open_chats": "Apri chat",
    "open_inbox": "Apri la posta in arrivo",
    "primary_identity": "IDENTITÀ PRIMARIA",
    "recent_chats": "Nuove chat",
    "recent_messages": "Ultime notizie",
    "session_encrypted": "Sessione crittografata: {nome}",
    "session_secure": "STATO: SICURO",
    "system_verlassen": "Uscire dal sistema",
    "write_message": "Scrivi un messaggio",
    "onboarding_step_profile": "Profilo",
    "onboarding_step_security": "Protezione",
    "onboarding_step_backup": "Backup",
    "onboarding_step_launch": "Avvia",
    "onboarding_loading_gaia_id": "Caricamento Gaia-ID",
    "onboarding_setup_kicker": "Configurazione Iniziale di GaiaCom",
    "onboarding_profile_title": "Rendi GaiaCom il tuo spazio.",
    "onboarding_profile_desc": "Il tuo nome visualizzato e avatar rimangono sotto controllo locale e possono essere modificati nel profilo in qualsiasi momento.",
    "onboarding_security_title": "Cosa GaiaCom protegge per te in questo momento.",
    "onboarding_security_desc": "GaiaCom separa identità, chiavi, messaggi e stato della rete. Qui vedi solo la versione utente ridotta.",
    "onboarding_backup_title": "Un backup è la tua vera via d'uscita d'emergenza.",
    "onboarding_backup_desc": "Senza dati di ripristino, nessuno può salvare la tua identità. Questo è esattamente il punto della vera sicurezza end-to-end.",
    "onboarding_launch_title": "Pronto. Cosa vuoi fare prima?",
    "onboarding_launch_desc": "Puoi iniziare subito o terminare il tour e continuare a lavorare nella dashboard.",
    "onboarding_display_name": "Nome visualizzato",
    "onboarding_display_name_placeholder": "Come vuoi che GaiaCom ti mostri?",
    "onboarding_select_avatar": "Seleziona avatar",
    "onboarding_sec_identity_title": "Identità",
    "onboarding_sec_identity_desc": "Il tuo Gaia-ID è la tua ancora di rete. I contatti possono rilevare modifiche alle chiavi.",
    "onboarding_sec_messages_title": "Messaggi",
    "onboarding_sec_messages_desc": "Il contenuto viene decifrato localmente. I messaggi modificati ricevono nuove firme.",
    "onboarding_sec_network_title": "Rete",
    "onboarding_sec_network_desc": "Il Centro Sicurezza e il Centro Segnalazioni rendono visibili i rischi, senza backdoor globali.",
    "onboarding_sec_transparency_title": "Trasparenza",
    "onboarding_sec_transparency_desc": "Registra eventi rilevanti per la sicurezza nel registro per mantenere tracciabili gli avvisi.",
    "onboarding_backup_notice_title": "Importante per gli utenti normali",
    "onboarding_backup_notice_desc": "Salva i tuoi dati di ripristino separatamente da questo dispositivo. In caso di perdita di password e backup, GaiaCom rimarrà intenzionalmente bloccato.",
    "onboarding_backup_consent": "So che il mio backup è fondamentale per il ripristino e il cambio di dispositivo.",
    "onboarding_inbox_title": "Posta in arrivo",
    "onboarding_inbox_desc": "Leggi le email e scrivi il tuo primo messaggio.",
    "onboarding_contacts_title": "Contatti",
    "onboarding_contacts_desc": "Verifica il primo contatto o avvia una chat.",
    "onboarding_channels_title": "Canali",
    "onboarding_channels_desc": "Scopri le frequenze pubbliche.",
    "onboarding_security_title_card": "Centro Sicurezza",
    "onboarding_security_desc_card": "Visualizza lo stato di GaiaShield.",
    "onboarding_later": "Più tardi",
    "onboarding_back": "Indietro",
    "onboarding_continue": "Continua",
    "onboarding_complete_setup": "Completa configurazione",
    "auth_legal_consent": "Ho letto e accetto l'informativa sulla privacy e le condizioni d'uso.",
    "auth_show_terms": "Mostra le condizioni d'uso",
    "auth_recovery_mode": "Modalità ripristino",
    "auth_recovery_import_title": "Importa file di recupero",
    "auth_recovery_import_desc": "Ripristina le tue chiavi GaiaCom da un file di backup protetto da password. Successivamente, la mnemonica e il nome utente saranno precompilati.",
    "auth_recovery_file_pwd_placeholder": "Password del file di recupero",
    "auth_recovery_local_pwd_placeholder": "Nuova password di sblocco locale min. 12 caratteri",
    "auth_recovery_importing": "Importazione...",
    "auth_recovery_decrypt": "Decifra recupero",
    "auth_back_to_login": "Torna al login",
    "auth_terms_title": "Condizioni d'uso di GaiaCom Beta",
    "auth_terms_close": "Chiudi",
    "auth_cookie_title": "GaiaCOM rimane sovrano.",
    "auth_cookie_desc": "Utilizziamo solo l'archiviazione locale tecnicamente necessaria per la lingua, la sessione e la sicurezza. Nessun tracciamento, nessun cookie pubblicitario, nessun profilo di terze parti.",
    "auth_cookie_accept": "Capito",
    "sc_explainer_title": "Cosa viene effettivamente protetto qui?",
    "sc_explainer_desc": "GaiaShield è lo strato protettivo tra il tuo account, i tuoi messaggi e la rete. Non decide sui contenuti, ma sui rischi tecnici: manipolazione, tentativi di replay, accesso non autorizzato, pattern di accesso sospetti e transizioni di gateway non sicure.",
    "sc_explainer_identity_desc": "Controlla le anomalie di accesso, i rischi di sessione e l'accesso ad altre identità.",
    "sc_explainer_messages_desc": "Rileva pattern di replay, buste manipolate e mancanza di caratteristiche di integrità.",
    "sc_explainer_network_desc": "Segnala rischi di federazione, limite di velocità e SMTP prima che la fiducia venga visualizzata in modo errato.",
    "sc_open_security_warnings": "Avvisi di sicurezza aperti",
    "sc_opt_all": "Tutti",
    "sc_opt_low": "Basso",
    "sc_opt_medium": "Medio",
    "sc_opt_high": "Alto",
    "sc_opt_critical": "Critico",
    "sc_opt_failed_login": "Accesso fallito",
    "sc_opt_auth_attack": "Attacco di autenticazione",
    "sc_opt_rate_limit": "Limite di frequenza",
    "sc_opt_policy_violation": "Avviso di criterio",
    "sc_opt_message_replay": "Replay di messaggio",
    "sc_node_security_data_unavailable": "Dati di sicurezza del nodo non disponibili",
    "sc_total_events": "Eventi totali",
    "sc_login_attacks": "Attacchi di accesso",
    "sc_rate_limits_active": "Limiti di frequenza attivi",
    "sc_smtp_shield_hits": "Impatto SMTP Shield",
    "sc_top_event_categories": "Principali categorie di eventi",
    "sc_no_entries": "Nessuna voce.",
    "sc_node_audit_log": "Registro di controllo del nodo (recenti)",
    "sc_no_node_events": "Nessun evento del nodo.",
    "archiv": "Archivio",
    "entwuerfe": "Bozze",
    "markiert": "Speciali",
    "wichtig": "Importanti",
    "snoozed": "Posticipati",
    "papierkorb": "Cestino",
    "spam": "Spam",
    "cancel": "Annulla",
    "error": "Errore",
    "success": "Successo",
    "kopieren": "Copia",
    "block_contact": "Blocca contatto",
    "unblock_contact": "Sblocca contatto",
    "report_contact": "Segnala contatto",
    "check_fingerprint": "Verifica impronta",
    "export_encrypted": "Esporta (Cifrato)",
    "export_gaiaproof": "Esporta (GaiaProof)",
    "export_password_prompt": "Inserisci una password per cifrare l'esportazione della chat:",
    "export_success": "Chat esportata e cifrata con successo.",
    "export_failed": "Esportazione fallita: ",
    "gaiaproof_export_success": "Pacchetto GaiaProof esportato con successo.",
    "gaiaproof_export_failed": "Esportazione GaiaProof fallita: ",
    "export_gaiaproof_confirm": "Desideri scaricare il pacchetto GaiaProof con tutte le firme e le ricevute di consegna del server? Potrebbe richiedere un momento.",
    "group_settings_is_private": "Stanza privata (non ricercabile pubblicamente, solo su richiesta)",
    "group_settings_read_only": "Modalità sola lettura (solo proprietario e admin possono inviare messaggi)",
    "group_settings_slow_mode": "Modalità lenta (cooldown invio)",
    "gsn_title": "Feed social GSN",
    "gsn_node_feed": "Feed del nodo",
    "gsn_following_feed": "Seguiti",
    "gsn_feed_empty": "Nessun post trovato.",
    "gsn_composer_placeholder": "Cosa c'è di nuovo nella federazione?",
    "gsn_post_btn": "Condividi",
    "gsn_profile": "Profilo utente",
    "gsn_followers": "Follower",
    "gsn_following": "Seguiti",
    "gsn_bio": "Descrizione / Bio:",
    "gsn_bio_label": "Descrizione / Bio",
    "gsn_display_name": "Nome visualizzato",
    "gsn_edit_profile": "Modifica profilo",
    "gsn_save_profile": "Salva",
    "gsn_add_image": "Aggiungi immagine (Cifrato)",
    "gsn_add_emoji": "Inserisci emoji",
    "gsn_avatar_emoji": "Avatar (Emoji)",
    "gsn_follow": "Segui",
    "gsn_unfollow": "Non seguire più",
    "gsn_repost": "Condividi / Ripubblica",
    "gsn_post_created": "Post condiviso con successo.",
    "gsn_image_uploaded": "Immagine cifrata e caricata.",
    "gsn_upload_failed": "Caricamento immagine fallito: ",
    "gsn_comment_placeholder": "Scrivi un commento...",
    "gsn_delete_confirm_title": "Eliminare il post?",
    "gsn_delete_confirm_desc": "Sei sicuro di voler eliminare permanentemente questo post?",
    "gsn_delete_comment_confirm_title": "Eliminare il commento?",
    "gsn_delete_comment_confirm_desc": "Sei sicuro di voler eliminare permanentemente questo commento?",
    "gsn_report": "Segnala",
    "gsn_report_title": "Segnala violazione",
    "gsn_report_category": "Categoria",
    "gsn_report_spam": "Spam / Pubblicità",
    "gsn_report_harassment": "Molestie / Incitamento all'odio",
    "gsn_report_abuse": "Abuso",
    "gsn_report_illegal": "Contenuto illegale",
    "gsn_report_severity": "Gravità",
    "gsn_report_low": "Basso",
    "gsn_report_medium": "Medio",
    "gsn_report_high": "Alto",
    "gsn_report_comment": "Commento aggiuntivo",
    "gsn_report_submit": "Segnala",
    "gsn_report_submitted": "Segnalazione inviata alla governance.",
    "gsn_report_post": "Segnala post",
    "report_group": "Segnala gruppo",
    "report_group_reason_prompt": "Inserisci un motivo per la segnalazione (opzionale):",
    "report_reason_prompt": "Inserisci un motivo per la segnalazione (opzionale):",
    "report_failed": "Segnalazione fallita: ",
    "report_success": "Contatto segnalato con successo.",
    "room_read_only_placeholder": "Solo proprietario e admin possono scrivere",
    "read_only_active": "Modalità sola lettura",
    "slow_mode_active": "Modalità lenta attiva",
    "kommandozentrale": "Centro di comando",
    "kontakt_blockiert": "Contatto bloccato",
    "kontakt_freigegeben": "Contatto sbloccato",
    "mailbox_settings_title": "Impostazioni casella postale",
    "mailbox_settings_desc": "Gestisci firma, lingua, filtri e-mail.",
    "mic_access_denied": "Accesso al microfono negato: ",
    "no_frequencies_active_desc": "Crea una nuova stanza per iniziare a comunicare.",
    "key_changed_warning_title": "AVVISO DI SICUREZZA:",
    "key_changed_warning_desc": "La chiave di identità di questo mittente è stata aggiornata o differisce da quella precedentemente nota. Si prega di verificare l'impronta tramite un altro canale sicuro.",
    "sc_col_category": "Categoria",
    "search_members": "Cerca membri...",
    "tab_general": "Generale",
    "tab_members": "Membri",
    "tab_requests": "Richieste",
    "tab_invites": "Inviti",
    "tab_logs": "Log",
    "auth_why_gaiacom": "Perché GaiaCOM?",
    "auth_why_gaiacom_desc": "L'alternativa sicura e decentralizzata per le tue comunicazioni riservate.",
    "auth_self_managed_id": "ID autogestito",
    "auth_self_managed_id_desc": "Crea istantaneamente identità crittografiche sicure senza fornire e-mail o numero di telefono.",
    "auth_gaiadrop_secure_exchange": "Scambio sicuro senza account",
    "auth_gaiadrop_benefit_e2ee": "Cifrato end-to-end",
    "auth_gaiadrop_benefit_no_login": "Nessun login richiesto",
    "auth_gaiadrop_benefit_inbox": "Consegna diretta nella posta in arrivo del destinatario",
    "auth_terms_of_use": "Condizioni d'uso",
    "auth_terms_of_use_show": "Mostra condizioni d'uso",
    "auth_consent_privacy_terms": "Ho letto e accetto l'informativa sulla privacy e le condizioni d'uso.",
    "auth_recovery_import_file": "Importa file di ripristino",
    "auth_recovery_password": "Password file di ripristino",
    "auth_recovery_local_password": "Nuova password di sblocco locale min. 12 caratteri",
    "auth_recovery_decrypting": "Decifratura ripristino in corso...",
    "auth_recovery_back": "Torna al login",
    "auth_cookie_sovereign": "GaiaCOM rimane sovrano.",
    "auth_cookie_sovereign_desc": "Utilizziamo solo funzionalità di archiviazione locale tecnicamente necessarie per la lingua, la sessione e la sicurezza. Nessun tracciamento, nessun cookie pubblicitario, nessun profilo di terze parti.",
    "auth_cookie_sovereign_accept": "Capito",
    "unlock_keyboard_toggle": "⌨️ Usa tastiera",
    "unlock_keypad_toggle": "🔢 Usa tastierino PIN",
    "unlock_status_denied": "ACCESSO NEGATO / RIPROVA",
    "unlock_status_decrypting": "DECIFRATURA CASSAFORTE...",
    "unlock_status_secured": "CASSAFORTE PROTETTA / BLOCCATA",
    "auth_landing_nav_legal": "Note Legali",
    "auth_landing_nav_beta": "Test Beta",
    "auth_landing_card1_title": "Crittografia Post-Quantistica (ML-KEM)",
    "auth_landing_card2_title": "100% Decentrato",
    "auth_landing_card3_title": "Zero-Knowledge",
    "auth_landing_card4_title": "Protezione dei Metadati",
    "auth_landing_card5_title": "Identità Autogestita",
    "auth_landing_hybrid_title": "Crittografia di oggi e protezione per il domani.",
    "auth_landing_hybrid_desc": "GaiaCom combina il collaudato scambio di chiavi classico con l'incapsulamento post-quantistico. Nessuna scelta cieca: difesa in profondità.",
    "auth_landing_x25519_desc": "Scambio di chiavi su curva ellittica rapido e collaudato per dispositivi attuali e sessioni sicure.",
    "auth_landing_mlkem_desc": "Incapsulamento post-quantistico per la riservatezza a lungo termine contro scenari di decifratura tardiva.",
    "auth_landing_cycle_title": "Il server non vede nulla. La rete trasporta solo rumore.",
    "auth_landing_step1_title": "Crittografia Locale",
    "auth_landing_step1_desc": "Il messaggio viene cifrato sul dispositivo del mittente, prima di raggiungere la rete o il server.",
    "auth_landing_step2_title": "Trasporto come Blob",
    "auth_landing_step2_desc": "Il pacchetto viaggia come rumore crittografico attraverso nodi federati o livelli di archiviazione decentralizzati.",
    "auth_landing_step3_title": "Archiviazione Federata",
    "auth_landing_step3_desc": "Nessuna casella di posta centrale come bersaglio. I dati sono frammentati, federati o decentralizzati e completamente cifrati.",
    "auth_landing_step4_title": "Decrittazione Locale",
    "auth_landing_step4_desc": "Solo la chiave privata del destinatario può convertire nuovamente il blob in contenuto leggibile.",
    "auth_landing_trinity_title": "Un concetto di protocollo. Tre livelli di infrastruttura.",
    "auth_landing_enterprise_desc": "Per aziende, studi legali, medie imprese, industria e private banking. Cerchi di comunicazione chiusi con controllo amministrativo, conformità e supporto.",
    "auth_landing_enterprise_list1": "Sovranità interna e amministrazione degli utenti",
    "auth_landing_enterprise_list2": "Nodo auto-ospitato o cluster sovrano gestito",
    "auth_landing_enterprise_list3": "SLA, supporto e moduli premium",
    "auth_landing_network_desc": "La rete aperta per la privacy digitale. Nessun commercio di dati, ma un'infrastruttura per la comunicazione libera e crittografata.",
    "auth_landing_network_list1": "Client open source",
    "auth_landing_network_list2": "Nodi federati",
    "auth_landing_network_list3": "Nessuna chiave di decrittazione centrale",
    "auth_landing_defend_desc": "Infrastruttura di alta sicurezza specializzata per autorità, infrastrutture critiche e silos di comunicazione isolati.",
    "auth_landing_defend_list1": "Distribuzioni isolate e disconnesse (air-gapped)",
    "auth_landing_defend_list2": "White label e audit del codice sorgente",
    "auth_landing_defend_list3": "Sovranità digitale nazionale",
    "auth_landing_gov_title": "Protocollo aperto. Esecuzione commerciale. Chiara separazione giuridica.",
    "auth_landing_gov_desc": "GaiaCom separa il protocollo aperto, i client aperti e l'infrastruttura premium commerciale. La fiducia deriva dalla trasparenza; i ricavi, dalle operazioni aziendali, dal supporto, dalle integrazioni e dai moduli speciali.",
    "auth_landing_price1_desc": "Quota di protezione bot per la distribuzione su AppStore/PlayStore.",
    "auth_landing_price2_desc": "Open Source per gli utenti che preferiscono compilarlo da soli.",
    "auth_landing_price3_desc": "Per medie imprese, studi legali e team sensibili.",
    "auth_landing_price4_desc": "Per grandi aziende, cluster ad alta disponibilità, LDAP e accesso root.",
    "auth_landing_license1_desc": "Massima trasparenza per utenti, fork e audit della comunità.",
    "auth_landing_license2_desc": "Protezione copyleft contro il furto cloud e fork di protocollo chiusi.",
    "auth_landing_license3_desc": "LDAP, accesso root, audit, SLA e logica di business specializzata.",
    "auth_landing_final_title": "Comunicazione secondo il modello di fiducia zero.",
    "auth_landing_final_desc": "GaiaCom non sostituisce semplicemente l'e-mail. Solleva la questione del perché la comunicazione riservata si basi ancora su caselle di posta centrali, server leggibili e presupposti vecchi di 40 anni.",
    "auth_landing_final_note": "Nota: Questa pagina descrive una visione architettonica e una roadmap. Le promesse di sicurezza devono essere confermate da implementazione, audit e test reali prima del loro impiego produttivo."




  };

export default it;